import axios from 'axios';

export const createRide = (values, token) => {
    return new Promise((result, reject) => {
        axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + "/api/v1/rides/create",
            data: values,
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(
            (res) => {
                result(res);
            }
        ).catch(err => {
            reject(err);
        });
    });
};

export const getRide = (values, token) => {
    return new Promise((result, reject) => {
        axios({
            method: "get",
            url: process.env.REACT_APP_API_URL + "/api/v1/rides/byId",
            params: values,
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then(
            (res) => {
                result(res);
            }
        ).catch(err => {
            reject(err);
        });
    });
};

export const saveRideImage = (values, token) => {
    return new Promise((result, reject) => {
        axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + "/api/v1/rides/imageRide",
            data: values,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": `Bearer ${token}`
            }
        }).then(
            (res) => {
                result(res);
            }
        ).catch(err => {
            reject(err);
        });
    });
};